import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { IRootState } from "../../../../../../reducer/CombineReducer";
import { CreateScheduleSlice } from "../../../CreateSchedule/redux";
import QuaterlyConfigView from "./QuaterlyConfig.view";

/**
 * Component will be rendered for quaterly recurrence type
 * Responsible for rendering the three quaterly radio buttons
 */
const QuaterlyConfig = (): JSX.Element => {
  const scheduling = useSelector((state: IRootState) => state.scheduling);
  const dispatch = useDispatch();
  const { schedulingDetails } = scheduling;
  const { recurrenceData } = schedulingDetails;

  /**
   * On quaterly radio button on change will be called
   * Selected radio button value will be updated in redux
   */
  const onFieldChange = (selected: string): void => {
    const tempRecurrenceData = {
      ...recurrenceData,
      month: +selected
    };
    dispatch(CreateScheduleSlice.actions.setNewScheduleDetails({
      ...scheduling.schedulingDetails,
      recurrenceData: tempRecurrenceData
    }));
  };

  return (
    <QuaterlyConfigView onFieldChange={onFieldChange}/>
  );
};

export default QuaterlyConfig;
